import { createApi } from "@reduxjs/toolkit/query/react";
import { extendedBaseQuery } from "../basequery";

export const countryApi = createApi({
  reducerPath: "countryApi",
  baseQuery: extendedBaseQuery,
  tagTypes: ["Country"],
  endpoints: (builder) => ({
    getCountries: builder.query({
      query: (params) => {
        const query = {};
        if (params?.skip) query.skip = params.skip;
        if (params?.limit) query.limit = params.limit;
        if (params?.search) query.search = params.search;
        if (params?.filter) query.filter = params.filter;
        if (params?.sortBy) query.sortBy = params.sortBy;
        if (params?.orderBy) query.orderBy = params.orderBy;

        return {
          url: `country?${new URLSearchParams(query).toString()}`,
          method: "GET",
        };
      },
      providesTags: ["Country"],
    }),
    createCountry: builder.mutation({
      query: (body) => ({
        url: "country",
        method: "POST",
        body,
      }),
      invalidatesTags: ["Country"],
    }),
    updateCountry: builder.mutation({
      query: (body) => ({
        url: `country/${body.id}`,
        method: "PATCH",
        body,
      }),
      invalidatesTags: ["Country"],
    }),
    deleteCountry: builder.mutation({
      query: (id) => ({
        url: `country/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Country"],
    }),
  }),
});

export const {
  useGetCountriesQuery,
  useCreateCountryMutation,
  useUpdateCountryMutation,
  useDeleteCountryMutation,
} = countryApi;
